import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {OneTimeConfirmationDialogComponent} from '../one-time-confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class OneTimeConfirmationDialogService {

  constructor(public dialog: MatDialog) {}

  onOk: () => void;

  public showPopup(storeKey, message, onOk): void {
    this.onOk = onOk;
    if (this.stopShowPopup(storeKey)) {
      this.onOk();
      return;
    }

    const dialogRef = this.dialog.open(OneTimeConfirmationDialogComponent, {
      width: '400px',
      data: {message, storeKey}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.onOk();
    });
  }

  private stopShowPopup(storeKey): boolean {
    const localStorageValue = localStorage.getItem(storeKey);
    return localStorageValue && localStorageValue === 'true';
  }
}
